module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Tender Winning Status"
    },
    model: {
      value: (_vm.objProjectStatusEdit.obj.tender_winning),
      callback: function($$v) {
        _vm.$set(_vm.objProjectStatusEdit.obj, "tender_winning", $$v)
      },
      expression: "objProjectStatusEdit.obj.tender_winning"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.descriptionRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objProjectStatusEdit.obj.description),
      callback: function($$v) {
        _vm.$set(_vm.objProjectStatusEdit.obj, "description", $$v)
      },
      expression: "objProjectStatusEdit.obj.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditProjectStatus()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('small', [_c('strong', [_vm._v("* The button will activate once all required fields have been completed")])])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}